import React, { useEffect, useState } from "react";
import {
    FeedCarouselButton,
    FeedCarouselCount,
    FeedImage,
    FeedMediaButton,
    FeedMediaError,
    FeedMediaExpandButton,
    FeedMediaFrame,
    FeedVideo
} from "src/components/NoticeboardFeedUi";
import { getNoticeMediaItems } from "../../feedUtils";

const NoticeboardFeedMedia = ({ notice, onOpenPost, modalMode, initialIndex, hideVideoPostButton }) => {
    const mediaItems = getNoticeMediaItems(notice);
    const [activeIndex, setActiveIndex] = useState(initialIndex || 0);
    const [failedMedia, setFailedMedia] = useState({});

    useEffect(() => {
        setActiveIndex(initialIndex || 0);
        setFailedMedia({});
    }, [initialIndex, notice.uuid]);

    if (!mediaItems.length) {
        return null;
    }

    const activeMedia = mediaItems[activeIndex];
    const isVideo = activeMedia.mediaType === "video" || Boolean(activeMedia.videoUrl);
    const mediaUrl = isVideo ? activeMedia.videoUrl : activeMedia.imageUrl;
    const mediaLabel = `${notice.subject || "Noticeboard post"} media ${activeIndex + 1} of ${mediaItems.length}`;
    const goToMedia = (offset) => {
        setActiveIndex(currentIndex => (
            (currentIndex + offset + mediaItems.length) % mediaItems.length
        ));
    };
    const mediaContent = failedMedia[activeMedia.uuid] ? (
        <FeedMediaError role="status">This media could not be loaded.</FeedMediaError>
    ) : isVideo ? (
        <FeedVideo
            key={activeMedia.uuid}
            src={mediaUrl}
            poster={activeMedia.previewImageUrl || undefined}
            width={activeMedia.width}
            height={activeMedia.height}
            controls
            preload="metadata"
            aria-label={mediaLabel}
            $detail={modalMode}
            onError={() => setFailedMedia(current => ({ ...current, [activeMedia.uuid]: true }))}
        />
    ) : (
        <FeedImage
            key={activeMedia.uuid}
            src={mediaUrl}
            alt={mediaLabel}
            width={activeMedia.width}
            height={activeMedia.height}
            loading="lazy"
            $detail={modalMode}
            onError={() => setFailedMedia(current => ({ ...current, [activeMedia.uuid]: true }))}
        />
    );

    return (
        <FeedMediaFrame $detail={modalMode}>
            {!isVideo && !modalMode && onOpenPost ? (
                <FeedMediaButton
                    type="button"
                    aria-label={`Open complete post from ${mediaLabel}`}
                    onClick={onOpenPost}
                >
                    {mediaContent}
                </FeedMediaButton>
            ) : mediaContent}
            {isVideo && !modalMode && onOpenPost && !hideVideoPostButton && (
                <FeedMediaExpandButton
                    type="button"
                    aria-label={`Open complete post from ${mediaLabel}`}
                    onClick={onOpenPost}
                >
                    View post
                </FeedMediaExpandButton>
            )}
            {mediaItems.length > 1 && (
                <>
                    <FeedCarouselButton
                        type="button"
                        $side="left"
                        aria-label="Previous media"
                        onClick={() => goToMedia(-1)}
                    >
                        ‹
                    </FeedCarouselButton>
                    <FeedCarouselButton
                        type="button"
                        $side="right"
                        aria-label="Next media"
                        onClick={() => goToMedia(1)}
                    >
                        ›
                    </FeedCarouselButton>
                    <FeedCarouselCount aria-live="polite">
                        {activeIndex + 1} / {mediaItems.length}
                    </FeedCarouselCount>
                </>
            )}
        </FeedMediaFrame>
    );
};

export default NoticeboardFeedMedia;
